import { createGenericSlice, DjangoModel } from '@store/slices/generic.slice'
import { EntityId } from '@reduxjs/toolkit'
import { RootState } from '@store/store'

export const areaUrl = 'area'

export interface AreaModel extends DjangoModel {
  name: string
  api8bcId: string
  stationId: EntityId
  position: number
  shortcut: string
}

const {
  slice: areaSlice,
  thunks: areaThunks,
  adapter: areaAdapter,
  selectors,
} = createGenericSlice<AreaModel>(
  'area',
  areaUrl,
  {}
  //areaExtraReducers  Initial state can be customized if needed
)

// export const areaAdapterExport = areaAdapter

export const { selectAll: selectAllAreas, selectById: selectAreaById } =
  areaAdapter.getSelectors<RootState>((state: RootState) => state.area)

export const { fetchAll: fetchAllAreas } = areaThunks
export const {
  selectLoading: selectAreaLoading,
  selectIsIdInProgress: selectIsAreaIdInProgress,
  selectError: selectAreaError,
} = selectors

export default areaSlice.reducer
